import { render, staticRenderFns } from "./search.vue?vue&type=template&id=21bd8dc5&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=21bd8dc5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd8dc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21bd8dc5')) {
      api.createRecord('21bd8dc5', component.options)
    } else {
      api.reload('21bd8dc5', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=21bd8dc5&scoped=true", function () {
      api.rerender('21bd8dc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolUpdate/components/search.vue"
export default component.exports